import { UseQueryResult } from '@tanstack/react-query';
import {
    useGetAllFsps1,
    useGetFspsByType as useGetFspsByTypeApi,
    useGetFspByCode1
} from '@/shared/api/client/fsp';
import { FspDto, FspType } from '@/shared/api/model';

/**
 * Hook to fetch all FSPs
 */
export function useGetAllFsps(): [UseQueryResult<FspDto[], Error>, () => void] {
    // Use the Orval-generated hook
    const query = useGetAllFsps1();
    // @ts-ignore

    // Extract data from nested axios response and maintain the original interface
    const result = {
        ...query,
        data: query.data,
        error: query.error as Error
    } as UseQueryResult<FspDto[], Error>;

    const refetch = () => query.refetch();

    return [result, refetch];
}

/**
 * Hook to fetch FSPs by type (MNO or BANK)
 */
export function useGetFspsByType(
    fspType: FspType
): [UseQueryResult<FspDto[], Error>, () => void] {
    // Use the Orval-generated hook
    const query = useGetFspsByTypeApi(fspType);

    // Extract data from nested axios response and maintain the original interface
    // @ts-ignore
    const result = {
        ...query,
        data: query.data,
        error: query.error as Error
    } as UseQueryResult<FspDto[], Error>;

    const refetch = () => query.refetch();

    return [result, refetch];
}

/**
 * Hook to fetch specific FSP by code
 */
export function useGetFspByCode(
    code: string
): [UseQueryResult<FspDto, Error>, () => void] {
    // Use the Orval-generated hook
    const query = useGetFspByCode1(code);

    // Extract data from nested axios response and maintain the original interface
    // @ts-ignore
    const result = {
        ...query,
        data: query.data,
        error: query.error as Error
    } as UseQueryResult<FspDto, Error>;

    const refetch = () => query.refetch();

    return [result, refetch];
}